export const SET_ID_DETAILS_PAYMENT = "SET_ID_DETAILS_PAYMENT"
export const CLEAR_DETAILS_PAYMENT_ID = "CLEAR_DETAILS_PAYMENT_ID"
